import { DataAssetSummaryResponse } from './useGetDataAssets'

export function groupDataAssets(data: DataAssetSummaryResponse[]) {
  const groupedByEntityType: Record<string, DataAssetSummaryResponse[]> = {}

  data
    .filter((item) => (item.entity?.id ?? 0) > 0 && !!item.entity?.name)
    .forEach((item) => {
    const entityTypeName = item.entity.entity_type.name
    if (!groupedByEntityType[entityTypeName]) {
      groupedByEntityType[entityTypeName] = []
    }
    groupedByEntityType[entityTypeName].push(item)
  })

  return {
    items: Object.entries(groupedByEntityType).map(([groupName, groupItems]) => {
      const groupedByEntityName: Record<string, DataAssetSummaryResponse[]> = {}

      groupItems.forEach((item) => {
        const entityName = item.entity.name
        if (!groupedByEntityName[entityName]) {
          groupedByEntityName[entityName] = []
        }
        groupedByEntityName[entityName].push(item)
      })

      const subgroups = Object.entries(groupedByEntityName).map(([name, items]) => ({
        name,
        items,
      }))

      return {
        groupName,
        items: subgroups,
      }
    }),
    allDataAssets: data,
  }
}

/**
 * Filters template items based on state and search criteria
 */
export const filterDataAssets = (
  summary: DataAssetSummaryResponse[] | undefined,
  filter: string,
  search: string
): DataAssetSummaryResponse[] => {
  if (!summary) return []

  return summary.filter((item) => {
    // Apply state filter
    const stateMatches = filter === 'All' || item.state === filter

    // Apply search filter if search string exists
    if (!search) return stateMatches

    const searchLower = search.toLowerCase()
    const dataAssetNameMatches = item.data_asset?.name?.toLowerCase().includes(searchLower) || false
    const fileNameMatches = item.file_name?.toLowerCase().includes(searchLower) || false

    return stateMatches && (dataAssetNameMatches || fileNameMatches)
  })
}
